import React, { Component } from "react";
import PropTypes from "prop-types";

class ContentPageShareTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			firstTabselected: true
		};
	}
	tabSelector = () => {
		this.setState({ firstTabselected: !this.state.firstTabselected });
	};
	render() {
		const { label, selectedTab, onClick } = this.props;
		return (
			<button
				className={`content-page-share-tab-item ${selectedTab === label ? "selected" : ""}`}
				aria-label={label}
				onClick={onClick}
				data-qa={`content-page-share-tab-${label.replace(/ /g, "")}`}
			>
				{label}
			</button>
		);
	}
	static propTypes = {
		label: PropTypes.string,
		selectedTab: PropTypes.string
	};
}

export default ContentPageShareTab;
